import Application from "~/enums/Application";
import type {Head} from "@unhead/vue";
import {useYandexStore} from "~/stores/yandex";

export const appHead: (app: Application) => Promise<Head> = async function (app: Application) {
  const head: Head = {
    meta: [],
    script: []
  };

  const {yandex: {metrika: {web: webMetrikaId, mini_app: miniAppMetrikaId}} } = useAppConfig();

  let yandexMetrikaId: number | null;

  switch (app) {
    case Application.MiniApp:
      yandexMetrikaId = miniAppMetrikaId;

      break;
    default:
      yandexMetrikaId = webMetrikaId;

      break;
  }

  if (yandexMetrikaId) {
    useYandexStore().setMetrikaId(yandexMetrikaId);
  }

  return head;
};